/** 由于antd过期写法提示使用console.error，通过webpack的alias重定向到这里，使用console.warn提示 */

/* eslint-disable import/no-mutable-exports */

const emptyFunction = () => {};

export let warning = emptyFunction;
export let note = emptyFunction;
export let resetWarned = emptyFunction;
export let call = emptyFunction;
export let warningOnce = emptyFunction;
export let noteOnce = emptyFunction;

if (process.env.NODE_ENV !== "production") {
  let warned = {};
  warning = function(valid, message) {
    if (!valid && console !== undefined) {
      console.warn(`Warning: ${message}`);
    }
  };

  note = function(valid, message) {
    if (!valid && console !== undefined) {
      console.warn(`Note: ${message}`);
    }
  };

  resetWarned = function() {
    warned = {};
  };

  call = function(method, valid, message) {
    if (!valid && !warned[message]) {
      method(false, message);
      warned[message] = true;
    }
  };

  warningOnce = function(valid, message) {
    call(warning, valid, message);
  };

  noteOnce = function(valid, message) {
    call(note, valid, message);
  };
}

export default warningOnce;
